module.exports = __webpack_public_path__ + "img/23.1.766ca035.jpg";